import { ReactNode } from 'react'

import Header from './Header'

export function ButtonFrames({
  title,
  description,
  children,
}: {
  title: string
  description: string
  children: ReactNode
}): React.ReactElement {
  return (
    <div className="w-full">
      <Header className="my-0" isTextWhite>
        {title}
      </Header>
      <div className="max-w-3xl mt-8">
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 auto-rows-fr gap-8">{children}</div>
        <section className="w-full mt-6 self-start rounded gradient-border-container">
          <p className="font-medium bg-white p-5 rounded">{description}</p>
        </section>
      </div>
    </div>
  )
}
